<template>
  <el-image class="video" :src="posterUrl" fit="cover" />
</template>

<script lang="ts">
import { ref, watch, defineComponent } from 'vue';
import { getVideoPosterUrl } from './utils'

export default defineComponent({
  name: 'Preview',
  props: {
    url: { type: String }
  },
  setup(props) {

    const posterUrl = ref()

    watch(() => props.url, (val, oldVal) => {
      console.log('val: ', val);
      getVideoPosterUrl(props.url || '').then(url => {
        posterUrl.value = url
      })
    }, { immediate: true })
    
    return {
      posterUrl
    }
  }
})



</script>


<style scoped lang="scss">
.video::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 40px;
  height: 40px;
  z-index: 999;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background: radial-gradient(transparent 15px, #fff 16px);
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
}

.video::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0px;
  height: 0px;
  z-index: 999;
  transform: translate(-50%, -50%);
  margin-left: 6px;
  border-left: #fff solid 16px;
  border-top: transparent solid 8px;
  border-right: transparent solid 8px;
  border-bottom: transparent solid 8px;
}
</style>